import routes from "./routes";

const App = () => routes;

export default App;
